/**
 * @file 工具页hooks
 * @author FengGuang(fengguang01@baidu.com)
 */

import {useEffect, useState} from 'react';
import {fetchGetToolsList} from '../../api/pages/toolsApi';
import {IToolItem} from './types';

// 预请求
let preRequest: any = {};
if (window) {
    preRequest.fetchGetToolsList = fetchGetToolsList();
}

const useToolsHooks = () => {
    const [toolList, setToolList] = useState<IToolItem[]>([]);
    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetToolsList || fetchGetToolsList();
            delete preRequest.fetchGetToolsList;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const result = res.body.result;
                const data: any[] = (result || {}).data || [];
                const theToolList: IToolItem[] = data.map(item => {
                    let theTarget = !!item.target;
                    if (item.target === '0') {
                        theTarget = false;
                    }
                    return {
                        id: item.id,
                        link: item.link,
                        text: item.text,
                        title: item.title,
                        target: theTarget ? '_blank' : '',
                        tagText: item.tagText
                    };
                });
                setToolList(theToolList);
            }
        })();
    }, []);
    return {
        toolList
    };
};

export default useToolsHooks;
